'use client';

import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { useAuth } from '@/lib/auth-context';
import { useT } from '@/lib/i18n';

function isActive(pathname: string, href: string) {
  if (href === '/') return pathname === '/' || pathname.startsWith('/prompt/');
  return pathname === href || pathname.startsWith(`${href}/`);
}

export default function BottomAppNav() {
  const pathname = usePathname();
  const { user } = useAuth();
  const t = useT();

  const libraryHref = user ? '/my/saved' : '/trending';
  const libraryLabel = user ? t('nav.saved') : t('nav.trending');
  const libraryIcon = user ? 'bookmark' : 'local_fire_department';

  return (
    <nav className="bottom-app-nav" aria-label="Mobile app navigation">
      <Link
        href="/"
        className="bottom-app-nav-item no-underline"
        aria-current={isActive(pathname, '/') ? 'true' : undefined}
      >
        <span className="material-symbols-outlined">home</span>
        <span>{t('nav.home')}</span>
      </Link>

      <Link
        href="/explore"
        className="bottom-app-nav-item no-underline"
        aria-current={isActive(pathname, '/explore') ? 'true' : undefined}
      >
        <span className="material-symbols-outlined">explore</span>
        <span>{t('nav.explore')}</span>
      </Link>

      <Link
        href={user ? '/create' : '/auth/login'}
        className="bottom-app-nav-create no-underline"
        aria-label={t('nav.new_prompt')}
      >
        <span className="material-symbols-outlined">add</span>
      </Link>

      <Link
        href={libraryHref}
        className="bottom-app-nav-item no-underline"
        aria-current={isActive(pathname, libraryHref) ? 'true' : undefined}
      >
        <span className="material-symbols-outlined">{libraryIcon}</span>
        <span>{libraryLabel}</span>
      </Link>

      <button
        type="button"
        className="bottom-app-nav-item"
        aria-label="Open menu"
        onClick={() => window.dispatchEvent(new CustomEvent('mobiledrawer:open'))}
      >
        <span className="material-symbols-outlined">menu</span>
        <span>Menu</span>
      </button>
    </nav>
  );
}
